<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="pt01"><div class="partHead" id="ph01"><a id="page1"><h2 class="partNumber"><span class="bold"><span>PART ONE</span></span></h2><h2 class="partTitle">The Wish</h2><p class="partSubtitle"><span>Fire at morning,<br/>
fire in rain.</span></p></a><a id="page2"></a></div><div class="partBody"></div></div>
<a id="page2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// draycotteverlasting_pt01.vue?432bc6fc